import React, {useId} from 'react';
import {DatasetBarChartProps} from "components/dashboard/charts/interfaces";
import ChartWrapper from "components/dashboard/charts/ChartWrapper/ChartWrapper";
import DatasetBarChart from "components/dashboard/charts/bar-chart/DatasetBarChart";
import {APIResponseToDatasetDataInfoResponseArray} from "components/dashboard/charts/bar-chart/DatasetBarChartDataConverter";

const DatasetBarChartRenderer = (props: DatasetBarChartProps) => {
    const uniqueId = useId();

    return <ChartWrapper uniqueKey={uniqueId}
                         identifiers={props.identifiers}
                         showDateSelection={true}
                         promiseHandler={APIResponseToDatasetDataInfoResponseArray}
                         updateFrequency={props.updateFrequency}
                         loadConf={props.loadConf}
                         hideRefresh={props.hideRefresh}
                         dynamicHeight={props.dynamicHeight}
                         referenceTime={props.referenceTime}
                         datasetChart={"bar"}
                         width={props.width}
                         reportMode={props.reportMode}
    >
        {(wrapper: any) => (
            <div>
                <DatasetBarChart data={wrapper.data}
                                 width={wrapper.width}
                                 height={wrapper.height}
                                 dateFormat={props.dateFormat}
                />
            </div>
        )}
    </ChartWrapper>
}

export default DatasetBarChartRenderer;